import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { space } from '@/styles';

import ProfileTile from './ProfileTile';

const style = {
  profilesList: css`
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
  `,
};

const ChartProfiles = ({ profiles, route, isLoggedIn, enableBio, seniorStaff }) => {
  return (
    <div css={[space.m.b16, style.profilesList]}>
      {profiles.map(p => (
        <ProfileTile
          key={p.PersonId}
          profile={p}
          route={route}
          isLoggedIn={isLoggedIn}
          enableBio={enableBio}
          seniorStaff={seniorStaff}
        />
      ))}
    </div>
  );
};

ChartProfiles.propTypes = {
  profiles: PropTypes.array,
};

ChartProfiles.defaultProps = {
  profiles: [],
};

export default connect(
  state => {
    const { auth } = state;
    const { isLoggedIn } = auth;
    return { isLoggedIn };
  },
  null
)(ChartProfiles);
